import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {HOTB} from "../HOTB";
import {BitmapText} from "pixi.js";
import {GameAssets} from "../GameAssets";
import {gsap, TimelineMax} from "gsap";
import {Logger} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {GameSounds} from "../sound/GameSounds";

export class WaysBoard extends PIXI.Container implements StageLayer {
    private _baseNoOfWays: number = 1024;
    private _board: PIXI.Sprite;
    private _waysCounter: BitmapText;
    private _waysCounterValArr: number[][] = JSON.parse(JSON.stringify(HOTB.model.data.symbolSizes));

    constructor() {
        super();
        this.init();
    }

    public show(): void {
        this.visible = true;
    }

    public hide(): void {
        this.visible = false;
    }

    public updateWaysCounter(reset: boolean = false): void {
        if (reset) {
            for (let reelId: number = 0; reelId < this._waysCounterValArr.length; reelId++) {
                let symbolsInReel: number[] = this._waysCounterValArr[reelId];
                for (let symId: number = 0; symId < symbolsInReel.length; symId++) {
                    symbolsInReel[symId] = 1;
                }
            }
        }

        const counter: PIXI.BitmapText = this._waysCounter;
        const from: string = counter.text;
        const to: number = this.getFinalWaysCount();
        const duration: number = reset ? 0.1 : 0.2;

        const tl: TimelineMax = new TimelineMax({
            onUpdate: (): void => {
                counter.text = Math.round(Number(counter.text)).toString();
                const scale: number = Math.min(90 / (this._waysCounter.width), 1);
                counter.scale.set(scale);
            },
            onComplete: (): void => {
                counter.text = Math.round(to).toString();
                const scale: number = Math.min(90 / (this._waysCounter.width), 1);
                counter.scale.set(scale);
            }
        });
        tl.add(() => {
            if (!reset && to !== this._baseNoOfWays) {
                HOTB.soundPlayer.playSound(GameSounds.WAYS_COUNTER);
            }
        })
        tl.fromTo(counter, duration, {text: from}, {text: to + ""});

        if(HOTB.model.isActionSpinToBonus){
            tl.totalProgress(1);
        }
    }

    public updateWaysCounterFromLaunchBtn(reelId: number, symId: number, multValue: number): void {
        this._waysCounterValArr[reelId][symId] = multValue;
        this.updateWaysCounter();
    }

    public updateWaysCounterFromXSplit(symId: number): void {
        for (let reelId: number = 0; reelId < this._waysCounterValArr.length; reelId++) {
            this._waysCounterValArr[reelId][symId] = HOTB.model.gameData.symbolSizes[reelId][symId];
        }

        this.updateWaysCounter();
    }

    public updateFinalWaysCounter(): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();

        this._waysCounterValArr = JSON.parse(JSON.stringify(HOTB.model.data.symbolSizes));

        tl.add(() => this.updateWaysCounter(false), 0);

        return tl;
    }

    public getFinalWaysCount(): number {
        let calcTotalWays: number = 1;

        for (let reelId: number = 0; reelId < this._waysCounterValArr.length; reelId++) {
            let waysPerReel: number = 0;
            const symbolsInReel: number[] = this._waysCounterValArr[reelId];
            for (let symId: number = 0; symId < symbolsInReel.length; symId++) {
                waysPerReel += symbolsInReel[symId];
            }
            calcTotalWays *= waysPerReel;
        }

        Logger.logDev("totalWays:", calcTotalWays);
        return calcTotalWays;
    }

    public updateWaysCounterFromXNudge(reelId: number): void {
        for (let symId: number = 0; symId < this._waysCounterValArr[reelId].length; symId++) {
            this._waysCounterValArr[reelId][symId] = 1;
        }
        this.updateWaysCounter();
    }

    private init(): void {
        this.position.set(58, 172);
        this.createBoard();
        this.createWaysCountUp();
    }

    private createBoard(): void {
        this._board = new PIXI.Sprite(HOTB.assetLoader.getTextures("gameWaysBg")[0]);
        this._board.anchor.set(0.5);
        this._board.position.set(0)
        this.addChild(this._board);
    }

    private createWaysCountUp(): void {
        this._waysCounter = new PIXI.BitmapText("0000", {
            fontName: GameAssets.GAME_MULTIPLIER,
            fontSize: 4,
            align: "center",
            maxWidth: 90
        });
        this.updateWaysCounter(true); // as per initial reel set

        this._waysCounter.position.set(-2, 10);
        this._waysCounter.anchor = 0.5;
        this.addChild(this._waysCounter);
        this._waysCounter.alpha = 0.8;
    }
}